import React from "react";
import {Badge, Tabs} from "antd";
import {useProject} from "../../../providers/ClientProjectProvider";
import {useSearchParams} from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ProjectPhasesTable from "./ProjectPhasesTable";
import InfoTooltip from "../../../components/InfoTooltip";
import {useProjectScope} from "./ProjectScopeProvider";
import ProjectTeamsTable from "./ProjectTeamsTable";
import FixedFeeScopingForm from "../project-tools/FixedFeeScopingForm";


const ManageProjectScopeTable = (props) => {
    const {
        project,
        isProjectUpdating,
    } = useProject();

    const [searchParams, setSearchParams] = useSearchParams();
    const {scope, cancelEdit, setEditingKey, editingKey} = useProjectScope();


    return (
        <div className="manage-scope-table flex flex-col items-stretch gap-3">
            <div className="flex-grow flex flex-row justify-between bg-white gap-6 px-4 py-4">
                <div className="flex flex-col gap-1.5 items-start">
                    <p className="text-xs font-semibold">
                        Total Hours
                    </p>
                    <p className="text-primary text-lg">
                        {TB.sumBy(scope.phases, 'total_hours')} hours
                    </p>
                </div>
                <div className="flex flex-col gap-1.5 items-start">
                    <p className="text-xs font-semibold flex flex-row gap-1.5 items-center">
                        <span>
                            Estimated Client Cost
                        </span>
                        <InfoTooltip placement="right" type="dark">
                            <span className="text-xs px-2 py-3 text-white">
                                Estimated Cost is based on the Standard Platform Market Rate for each role.
                                The cost includes the project markup fee of {project.percent_markup || 0}%.
                            </span>
                        </InfoTooltip>
                    </p>
                    <p className="text-primary text-lg">
                        {TB.formatCurrency(TB.sumBy(scope.phases, 'estimated_cost'))}
                    </p>
                </div>

                <FixedFeeScopingForm/>
            </div>
            <div className="bg-white px-4">
                <div className="flex flex-col gap-4">

                    <Tabs
                        tabPosition="top"
                        onChange={async (key) => {
                            if (isProjectUpdating) return;

                            if (editingKey) {
                                await cancelEdit();
                                await setEditingKey(null)
                            }
                            let params = new URLSearchParams(searchParams);
                            params.set('tab', key);
                            setSearchParams(params)
                        }}
                        activeKey={searchParams.get('tab') || 'phases'}
                        size="large"
                        items={[
                            {
                                label: (
                                    <Badge
                                        count={!project.scope_confirmed_at ? (
                                            <i className="fas fa-exclamation-circle text-danger"/>
                                        ) : 0}>
                                        <p className={TB.mapClass("text-base", {
                                            "pr-2": !project.scope_confirmed_at,
                                            "font-medium": searchParams.get('tab') !== 'teams'
                                        })}>
                                            Scope Template
                                        </p>
                                    </Badge>
                                ),
                                key: 'phases',
                                children: (
                                    <ProjectPhasesTable/>
                                ),
                            },
                            // {
                            //     label: `Role Overview`,
                            //     key: 'roles',
                            //     children: (
                            //         <div className="px-4 py-8">
                            //             <ProjectDisciplinesTable/>
                            //         </div>
                            //     ),
                            // },
                            {
                                label: (
                                    <Badge color={TB.config('color.secondary')}
                                           count={project.shortlisted_candidates_count || 0}>
                                        <p className={TB.mapClass("text-base", {
                                            "mr-3": project.shortlisted_candidates_count > 0,
                                            "opacity-30": !project.shortlisted_candidates_count,
                                            "font-medium": searchParams.get('tab') === 'teams'
                                        })}>
                                            Team Scopes
                                        </p>
                                    </Badge>
                                ),
                                key: 'teams',
                                disabled: !project.shortlisted_candidates_count,
                                children: (
                                    <ProjectTeamsTable/>
                                ),
                            }
                        ]}

                    />


                </div>
            </div>
            {isProjectUpdating && (
                <div
                    className="inset-0 absolute z-10 flex flex-col items-center justify-center bg-[rgba(0,0,0,0.05)]">
                    <LoadingSpinner type="primary" size="lg"/>
                </div>
            )}
        </div>
    )
}

export default ManageProjectScopeTable